import React, { useCallback, useState } from 'react'
import { Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { stopPropagation } from '../../../Helpers/GenericHelpers'

function BarcodeEditInput(props) {
  const [inputValue, setInputValue] = useState('')

  const onEditBarcodeChange = useCallback(
    e => {
      setInputValue(e.target.value)
      const objToSave = { ...props.barcodes }
      objToSave.sizeValues['' + props.size + ''] = '' + e.target.value + ''
      props.setBarcodeValues(objToSave)
    },
    [props],
  )

  return (
    <Input
      value={inputValue}
      onClick={stopPropagation}
      onChange={e => {
        onEditBarcodeChange(e)
      }}
      allowClear={{ clearIcon: <CloseOutlined className='general-icon input-clear-icon' /> }}
    />
  )
}

export default BarcodeEditInput
